import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_ACCOUNT_PERMISSIONS,
  FETCH_ACCOUNT_PERMISSIONS_ERROR,
  SET_ACCOUNT_PERMISSIONS,
} from '../../constants';

const fetchAccountPermissions = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_ACCOUNT_PERMISSIONS),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/accounts/${
          action.accountId
        }?v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_ACCOUNT_PERMISSIONS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_ACCOUNT_PERMISSIONS_ERROR,
            error,
          })
        )
      )
    )
  );

export default fetchAccountPermissions;
